import React from 'react';
import AboutYouIndex from "../../about_you";
export function aboutYouRoutes() { return [{ path: '/about_you', element: /*#__PURE__*/ React.createElement(AboutYouIndex, null) }]; }
